import type { ScoreRenderEvent } from './vexFlowMapper';

/** Ligaduras dentro del mismo compás (tieStart → tieStop consecutivos). */
export function intraBarTiesFromEvents(events: ScoreRenderEvent[]): [number, number][] {
  const pairs: [number, number][] = [];
  for (let i = 0; i < events.length - 1; i += 1) {
    const cur = events[i]!;
    const next = events[i + 1]!;
    if (cur.tieStart && next.tieStop) {
      pairs.push([i, i + 1]);
    }
  }
  return pairs;
}

export function tiesFromScoreEvents(events: ScoreRenderEvent[]): [number, number][] {
  return intraBarTiesFromEvents(events);
}

export interface FlatPhraseLayout {
  /** Índice global donde empieza cada compás en el array plano de notas. */
  barStarts: number[];
  /** Pares [from, to] en índices globales. */
  tiePairs: [number, number][];
  barCount: number;
}

/** Calcula índices globales y ligaduras (intra + entre compases) para un pentagrama continuo. */
export function layoutFlatPhraseTies(
  barEventGroups: ScoreRenderEvent[][],
  tieInFlags: boolean[],
  tieOutFlags: boolean[],
): FlatPhraseLayout {
  const barStarts: number[] = [];
  const tiePairs: [number, number][] = [];
  let globalIdx = 0;

  for (let b = 0; b < barEventGroups.length; b += 1) {
    barStarts.push(globalIdx);
    const events = barEventGroups[b] ?? [];
    for (const [from, to] of intraBarTiesFromEvents(events)) {
      tiePairs.push([globalIdx + from, globalIdx + to]);
    }
    if (b > 0 && tieInFlags[b] && tieOutFlags[b - 1]) {
      tiePairs.push([globalIdx - 1, globalIdx]);
    }
    globalIdx += events.length;
  }

  return { barStarts, tiePairs, barCount: barEventGroups.length };
}
